<template>
    <div class="yt-dc-list">
        <GridTable
            ref="gridTable"
            id="DCList"
            :key="componentKey"
            :title="`${title}${appendTitle || ''}`"
            urlPath="dynamicContentCms"
            :widthPopup="1024"
            :columns="columns"
            :schema="schema"
            :supportAddNew="false"
            :defaultServerParams="{ _fields: '_id,name,type,isActive', schoolId: filteredBySchool }" />
    </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
// import VueFormGenerator from 'vue-form-generator'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')

@Component()
export default class DCList extends BaseList {
    @appModule.State('userProfile') stateUserProfile

    watchStateSchools = false

    title = 'Dynamic Content'

    columns = [
        {
            label: 'ID',
            field: '_id',
            hidden: true
        },
        {
            label: 'Name',
            field: 'name',
            filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: 'Filter by Name', // placeholder for filter input
                filterValue: '' // initial populated value for this filter
            }
        },
        {
            label: 'Active',
            field: 'isActive',
            type: 'switch'
        },
        {
            label: 'Actions',
            field: 'actions'
        }
    ]

    schema = {
        fields: [
            {
                // label: 'ID (disabled text field)',
                model: '_id',
                type: 'input',
                inputType: 'hidden',
                readonly: true
                // disabled: true
            },
            {
                label: 'Name',
                model: 'name',
                type: 'input',
                inputType: 'text',
                placeholder: 'Name',
                required: true,
                validator: ['string']
            },
            {
                type: 'YTCKEditor',
                label: 'Text',
                model: 'text',
                required: true,
                validator: ['required']
            },
            {
                label: 'Active',
                model: 'isActive',
                type: 'switch',
                default: false,
                textOn: 'Active',
                textOff: 'Inactive'
            }
        ]
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dynamic-content/DCList.vue